import React, { useEffect, useRef, useState } from "react";
import CounterCard from "../../components/UserSideComponents/CounterCard";
import CounterBg from "../../Assets/Images/CounterImages/counterBg.webp";
import leaf from "../../Assets/Images/leaf.png";
import { Sparkles } from "lucide-react";

const stats = [
  { value: 250, label: "Happy Clients" },
  { value: 200, label: "Verify Service" },
  { value: 150, label: "Beauticians" },
  { value: 30, label: "Categories" },
];

const CounterSection = () => {
  const sectionRef = useRef(null);
  const [start, setStart] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
        } else {
          setStart(false);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{ backgroundImage: `url(${CounterBg})` }}
      className="relative text-white py-8 md:py-12 lg:py-16 bg-cover bg-center px-4 sm:px-8 md:px-10  lg:px-12 "
    >
      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-[#0E1A26]/85"></div>

      {/* CONTENT */}
      <div className="relative  mx-auto px-4 grid grid-cols-1 md:grid-cols-5 gap-8 items-center">
        {/* LEFT TEXT */}

        <div className="md:col-span-2 space-y-3">
          <div className="relative w-fit">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
            <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
              <img
                src={leaf}
                alt="leaf"
                className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
              />
              <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                OUR SERVICE
              </span>
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
            </div>
          </div>

          {/* Heading with gradient text */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-100 leading-tight tracking-tight">
            <span className="bg-gradient-to-r from-gray-100 via-gray-300 to-gray-100 bg-clip-text text-transparent">
              It’s Our,&nbsp;
            </span>
            <span className="relative">
              <span className="bg-gradient-to-r from-[#FF8A65] via-[#FF5722] to-[#FFC107] bg-clip-text text-transparent">
                Journey
              </span>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#FF8A65] to-[#FFC107] rounded-full" />
            </span>
          </h1>
        </div>

        {/* COUNTERS */}
        <div className="md:col-span-3 md:grid-cols-2 grid grid-cols-2 text-robotoflex lg:grid-cols-4 gap-6 text-center">
          {stats.map((item, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={200 + index * 200}
              data-aos-duration="1000"
            >
              <CounterCard
                key={index}
                value={item.value}
                label={item.label}
                start={start}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
